(() => {
const root = document.querySelector('[data-header-drawers]');
if (!root) return;

const overlay = root.querySelector('[data-drawer-overlay]');
const navDrawer = root.querySelector('[data-nav-drawer]');
const cartDrawer = root.querySelector('[data-cart-drawer]');
const navPanels = root.querySelector('[data-nav-panels]');
const subTitle = root.querySelector('[data-sub-title]');
const subList = root.querySelector('[data-sub-list]');

const btnOpenNav = root.querySelector('[data-open-nav]');
const btnOpenCart = root.querySelector('[data-open-cart]');
const btnCloseAll = root.querySelectorAll('[data-close-drawers]');

const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

const routesRoot = window.Shopify?.routes?.root || '/';

let lastFocus = null;
let openDrawer = null; // 'nav' | 'cart' | null
let cartBusy = false;  // prevent double-click spam

function lockScroll(lock) {
  document.documentElement.style.overflow = lock ? 'hidden' : '';
}

function setOverlay(show) {
  if (!overlay) return;
  overlay.hidden = !show;
}

function closeSubpanel() {
  navPanels?.classList.remove('is-subopen');

  if (subTitle) {
    subTitle.textContent = '';
    subTitle.style.display = 'none';
  }

  if (subList) subList.innerHTML = '';
}

function openNav() {
  lastFocus = document.activeElement;
  openDrawer = 'nav';

  navDrawer?.classList.add('is-open');
  navDrawer?.setAttribute('aria-hidden', 'false');
  btnOpenNav?.setAttribute('aria-expanded', 'true');

  setOverlay(true);
  lockScroll(true);
  closeSubpanel();

  navDrawer?.querySelector(FOCUSABLE)?.focus();
}

async function openCart({ refresh = true } = {}) {
  lastFocus = document.activeElement;
  openDrawer = 'cart';

  cartDrawer?.classList.add('is-open');
  cartDrawer?.setAttribute('aria-hidden', 'false');
  btnOpenCart?.setAttribute('aria-expanded', 'true');

  setOverlay(true);
  lockScroll(true);

  cartDrawer?.querySelector(FOCUSABLE)?.focus();

  if (refresh) {
    await loadCartDrawer();
    await syncCartUiAccurate();
    enforceMinusRules();
  }
}

function closeAll() {
  openDrawer = null;

  navDrawer?.classList.remove('is-open');
  cartDrawer?.classList.remove('is-open');

  navDrawer?.setAttribute('aria-hidden', 'true');
  cartDrawer?.setAttribute('aria-hidden', 'true');

  btnOpenNav?.setAttribute('aria-expanded', 'false');
  btnOpenCart?.setAttribute('aria-expanded', 'false');

  setOverlay(false);
  lockScroll(false);
  closeSubpanel();

  lastFocus?.focus?.();

  // close predictive dropdown too (nice UX)
  closeDropdown();
}

function trapFocus(e) {
  if (!openDrawer) return;

  const drawer = openDrawer === 'nav' ? navDrawer : cartDrawer;
  if (!drawer) return;

  const focusables = Array.from(drawer.querySelectorAll(FOCUSABLE)).filter(
    (el) => el.offsetParent !== null
  );
  if (!focusables.length) return;

  const first = focusables[0];
  const last = focusables[focusables.length - 1];

  if (e.key === 'Tab') {
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
}

// ---------- NAV: category -> populate sub panel ----------
root.querySelectorAll('[data-category-trigger]').forEach((btn) => {
  btn.addEventListener('click', () => {
    const title = btn.getAttribute('data-category-title') || 'Subcategories';
    const categoryUrl = btn.getAttribute('data-category-url') || '#';
    const jsonEl = btn.querySelector('script[data-subitems]');

    let items = [];
    try {
      items = JSON.parse(jsonEl?.textContent || '[]');
    } catch (e) {}

    if (subTitle) {
      subTitle.innerHTML = `
        <span class="navPanel__backText">${escapeHtml(title)}</span>
        <span class="navPanel__backChevron" aria-hidden="true">‹</span>
      `;
      subTitle.style.display = 'flex';
    }

    if (subList) {
      const viewAllItem = `
        <li class="navItem navItem--viewAll">
          <a class="navViewAll" href="${categoryUrl}">
            <span>View All ${escapeHtml(title)}</span>
            <span class="navViewAll__arrow" aria-hidden="true">→</span>
          </a>
        </li>
      `;

      const subItems = items
        .map(
          (i) =>
            `<li class="navItem"><a class="navLink" href="${i.url}">${escapeHtml(
              i.title
            )}</a></li>`
        )
        .join('');

      subList.innerHTML = viewAllItem + subItems;
    }

    navPanels?.classList.add('is-subopen');

    setTimeout(() => {
      subList?.querySelector('a,button')?.focus();
    }, 10);
  });
});

if (subTitle) {
  subTitle.addEventListener('click', closeSubpanel);
  subTitle.style.cursor = 'pointer';
  subTitle.title = 'Back';
}

overlay?.addEventListener('click', closeAll);

btnOpenNav?.addEventListener('click', openNav);
btnOpenCart?.addEventListener('click', () => openCart());
btnCloseAll.forEach((b) => b.addEventListener('click', closeAll));

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && openDrawer) closeAll();
  trapFocus(e);
});

// ---------- PREDICTIVE SEARCH (UPDATED) ----------
const searchInput = root.querySelector('[data-search-input]');
const clearBtn = root.querySelector('[data-search-clear]');
const searchBtn = root.querySelector('[data-search-btn]');
const dropdown = root.querySelector('[data-predictive-search-dropdown]');
const loading = root.querySelector('[data-predictive-search-loading]');
const results = root.querySelector('[data-predictive-search-results]');

const collectionImgCache = new Map(); // handle -> imageUrl string

function getCollectionHandleFromUrl(url) {
  // /collections/handle or /collections/handle/products/...
  try {
    const u = new URL(url, window.location.origin);
    const parts = u.pathname.split('/').filter(Boolean);
    const idx = parts.indexOf('collections');
    if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
  } catch (e) {}
  return '';
}

async function fetchCollectionImage(handle, signal) {
  if (!handle) return '';
  if (collectionImgCache.has(handle)) return collectionImgCache.get(handle);

  const res = await fetch(
    `${routesRoot}collections/${encodeURIComponent(handle)}?section_id=predictive-collection-card`,
    { headers: { Accept: 'text/html' }, signal }
  );
  if (!res.ok) return '';

  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const img = doc.querySelector('[data-pc-img]');
  const src = img?.getAttribute('src') || '';

  collectionImgCache.set(handle, src);
  return src;
}

let psAbort = null;
let psTimer = null;

function openDropdown() {
  if (dropdown) dropdown.hidden = false;
}
function closeDropdown() {
  if (dropdown) dropdown.hidden = true;
  if (loading) loading.hidden = true;
}
function setLoading(on) {
  if (loading) loading.hidden = !on;
}

function setSearchReady(on) {
  if (!searchBtn) return;
  searchBtn.classList.toggle('is-ready', !!on);
}

function getVariantIdFromUrl(url) {
  try {
    const parsed = new URL(url || '', window.location.origin);
    return parsed.searchParams.get('variant') || '';
  } catch (e) {
    return '';
  }
}

function choosePredictiveVariant(productJson, productUrl, query) {
  const variants = Array.isArray(productJson?.variants) ? productJson.variants : [];
  if (!variants.length) return null;

  const urlVariantId = getVariantIdFromUrl(productUrl);
  const fromUrl = urlVariantId
    ? variants.find((variant) => String(variant.id) === String(urlVariantId))
    : null;
  if (fromUrl) return fromUrl;

  const q = String(query || '').trim();
  if (q) {
    const exact = variants.find((variant) => String(variant.sku || '') === q);
    if (exact) return exact;

    const lower = q.toLowerCase();
    const exactInsensitive = variants.find(
      (variant) => String(variant.sku || '').toLowerCase() === lower
    );
    if (exactInsensitive) return exactInsensitive;

    const partial = variants.find((variant) =>
      String(variant.sku || '').toLowerCase().includes(lower)
    );
    if (partial) return partial;
  }

  return variants.find((variant) => variant.available) || variants[0] || null;
}

function productUrlWithVariant(url, variantId) {
  if (!url || !variantId) return url || '#';

  try {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.set('variant', String(variantId));
    return parsed.pathname + parsed.search + parsed.hash;
  } catch (e) {
    return url;
  }
}

async function enrichPredictiveProducts(products, signal, query) {
  const enriched = await Promise.all(
    products.map(async (p) => {
      const handle = getHandleFromUrl(p.url || '');
      const pj = await fetchProductJson(handle, signal);
      const variant = choosePredictiveVariant(pj, p.url || '', query);
      const baseUrl = p.url || (handle ? `${routesRoot}products/${handle}` : '#');

      return {
        title: p.title || pj?.title || '',
        url: variant?.id ? productUrlWithVariant(baseUrl, variant.id) : baseUrl,
        image: pj?.featured_image || '',
        sku: variant?.sku || ''
      };
    })
  );

  return enriched;
}

async function fetchPredictive(q) {
  if (!q || q.length < 2) {
    if (results) results.innerHTML = '';
    closeDropdown();
    return;
  }

  psAbort?.abort?.();
  psAbort = new AbortController();

  setLoading(true);
  openDropdown();

  // NOTE:
  // - Keep your existing resources (product/collection/article/page)
  // - But render PRODUCTS as "cart-style" rows with image + category (product_type)
  // - Collections/Pages stay as simple lists (as before)
  // Preserve the original predictive-search behaviour for normal words.
  // Only add SKU as a searchable field when the query looks SKU-like.
  const skuFieldOption = /[0-9_-]/.test(q)
    ? `&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku`
    : '';

  const url =
    `${routesRoot}search/suggest.json?q=${encodeURIComponent(q)}` +
    `&resources[type]=product,collection,article,page` +
    `&resources[limit]=6` +
    skuFieldOption +
    `&resources[options][unavailable_products]=hide`;

  try {
    const res = await fetch(url, {
      signal: psAbort.signal,
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) throw new Error('Bad response');
    const data = await res.json();

    const r = data?.resources?.results || {};
    const products = r.products || [];
    const collections = r.collections || [];
    const pages = r.pages || [];
    const articles = r.articles || [];

    let html = '';

    if (products.length) {
      // enrich before rendering so everything appears at once
      const enrichedProducts = await enrichPredictiveProducts(products, psAbort.signal, q);

      html += `<div class="psGroup">`;
      html += `<div class="psTitle">Products</div>`;
      html += `<div class="hdr__psList">`;

      html += enrichedProducts
        .map((p) => {
          const title = escapeHtml(p.title || '');
          const url = p.url || '#';
          const imgUrl = normalizeUrl(p.image || '');
          const sku = escapeHtml(p.sku || '');

          return `
            <a class="hdr__psCard" href="${url}" role="option" aria-label="${title}">
              <div class="hdr__psThumb">
                ${
                  imgUrl
                    ? `<img
                        src="${imgUrl}"
                        alt="${title}"
                        class="hdr__psImage"
                        width="64"
                        height="64"
                        loading="lazy"
                      >`
                    : `<div class="hdr__psImage hdr__psImage--placeholder" aria-hidden="true"></div>`
                }
              </div>

              <div class="hdr__psText">
                <div class="hdr__psTitle">${title}</div>
                ${sku ? `<div class="hdr__psMeta hdr__psSku">SKU: ${sku}</div>` : ''}
              </div>
            </a>
          `;
        })
        .join('');

      html += `</div></div>`;
    }

    if (collections.length) {
      const enrichedCollections = await Promise.all(
        collections.map(async (c) => {
          const handle = getCollectionHandleFromUrl(c.url || '');
          const img = await fetchCollectionImage(handle, psAbort.signal);

          return {
            title: c.title || '',
            url: c.url || '#',
            image: img || ''
          };
        })
      );

      html += `<div class="psGroup">`;
      html += `<div class="psTitle">Collections</div>`;
      html += `<div class="hdr__psList">`;

      html += enrichedCollections
        .map((c) => {
          const title = escapeHtml(c.title || '');
          const url = c.url || '#';
          const imgUrl = normalizeUrl(c.image || '');

          return `
            <a class="hdr__psCard" href="${url}" role="option" aria-label="${title}">
              <div class="hdr__psThumb">
                ${
                  imgUrl
                    ? `<img
                        src="${imgUrl}"
                        alt="${title}"
                        class="hdr__psImage"
                        width="64"
                        height="64"
                        loading="lazy"
                      >`
                    : `<div class="hdr__psImage hdr__psImage--placeholder" aria-hidden="true"></div>`
                }
              </div>
              <div class="hdr__psText">
                <div class="hdr__psTitle">${title}</div>
                <div class="hdr__psMeta">Collection</div>
              </div>
            </a>
          `;
        })
        .join('');

      html += `</div></div>`;
    }

    const misc = [...pages, ...articles];
    if (misc.length) {
      html += `<div class="psGroup"><div class="psTitle">Pages</div><ul class="psList">`;
      html += misc
        .map(
          (m) =>
            `<li><a class="psItem" href="${m.url}">${escapeHtml(m.title)}</a></li>`
        )
        .join('');
      html += `</ul></div>`;
    }

    if (!html) {
      html = `<div class="psEmpty" style="padding:12px;opacity:.7">No results</div>`;
    }

    if (results) results.innerHTML = html;
  } catch (e) {
    if (e.name !== 'AbortError') {
      if (results)
        results.innerHTML = `<div class="psEmpty" style="padding:12px;opacity:.7">No results</div>`;
    }
  } finally {
    setLoading(false);
  }
}

searchInput?.addEventListener('input', (e) => {
  const q = e.target.value.trim();

  setSearchReady(q.length > 0);

  const form = e.target.closest('.hdr__searchForm');
  form?.classList.toggle('has-value', q.length > 0);

  clearTimeout(psTimer);
  psTimer = setTimeout(() => fetchPredictive(q), 180);
});

searchInput?.addEventListener('blur', (e) => {
  const q = e.target.value.trim();
  if (!q) setSearchReady(false);
});

searchInput?.addEventListener('focus', (e) => {
  const q = e.target.value.trim();
  if (q.length >= 2 && results?.innerHTML) openDropdown();
});

clearBtn?.addEventListener('click', () => {
  if (!searchInput) return;

  searchInput.value = '';
  searchInput.closest('.hdr__searchForm')?.classList.remove('has-value');

  setSearchReady(false);
  results && (results.innerHTML = '');
  closeDropdown();
  searchInput.focus();
});

// Close on outside click
document.addEventListener('click', (e) => {
  // Don’t close predictive when clicking header controls (PC-friendly)
  if (e.target.closest('[data-open-nav], [data-open-cart]')) return;

  // Also don’t close if clicking inside the dropdown/results
  if (dropdown && dropdown.contains(e.target)) return;

  // Close only when clicking outside the header root
  if (!root.contains(e.target)) closeDropdown();
});

// Close when input loses focus (delay so clicking results still works)
searchInput?.addEventListener('blur', () => {
  setTimeout(() => {
    const ae = document.activeElement;

    // If focus moved to nav/cart open buttons, keep dropdown open
    const focusOnHeaderControls =
      ae && ae.closest && ae.closest('[data-open-nav], [data-open-cart]');

    // If focus is still somewhere inside header (buttons, dropdown, etc), keep it open
    const focusStillInHeader = ae && root.contains(ae);

    if (focusOnHeaderControls || focusStillInHeader) return;

    closeDropdown();
  }, 120);
});

function escapeHtml(str) {
  return String(str ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

const productJsonCache = new Map(); // handle -> { image, product_type, ... }

function getHandleFromUrl(url) {
  // works for /products/handle or /products/handle?variant=...
  try {
    const u = new URL(url, window.location.origin);
    const parts = u.pathname.split('/').filter(Boolean);
    const idx = parts.indexOf('products');
    if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
  } catch (e) {}
  return '';
}

async function fetchProductJson(handle, signal) {
  if (!handle) return null;
  if (productJsonCache.has(handle)) return productJsonCache.get(handle);

  const res = await fetch(`${routesRoot}products/${encodeURIComponent(handle)}.js`, {
    headers: { Accept: 'application/json' },
    signal
  });
  if (!res.ok) return null;

  const json = await res.json();
  productJsonCache.set(handle, json);
  return json;
}

function normalizeUrl(u) {
  if (!u) return '';
  return u.startsWith('//') ? `https:${u}` : u;
}

// ---------- CART HELPERS ----------
function centsToMoney(cents) {
  if (window.Shopify?.formatMoney) {
    try {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    } catch (e) {}
  }

  const amount = cents / 100;

  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 2
  }).format(amount);
}

function getLineElByKey(key) {
  return root.querySelector(`.cartDrawer__item[data-key="${CSS.escape(key)}"]`);
}

function getSubtotalEl() {
  return root.querySelector('[data-cart-subtotal]');
}

function getCheckoutBtn() {
  return root.querySelector('.cartDrawer__checkout');
}

function setCheckoutBusy(busy, text = 'Removing...') {
  const btn = getCheckoutBtn();
  if (!btn) return;

  const defaultText = 'View Cart / Checkout';
  const originalText = btn.dataset.originalText || defaultText;

  btn.dataset.originalText = originalText;
  btn.textContent = busy ? text : originalText;
  btn.classList.toggle('is-busy', busy);
  btn.setAttribute('aria-busy', busy ? 'true' : 'false');
}

function setSubtotalBusy(busy) {
  const el = getSubtotalEl();
  if (!el) return;

  // create overlay once
  let wrap = el.closest('[data-subtotal-wrap]');
  if (!wrap) {
    wrap = document.createElement('span');
    wrap.setAttribute('data-subtotal-wrap', '');
    wrap.style.position = 'relative';
    wrap.style.display = 'inline-block';

    const parent = el.parentNode;
    parent.insertBefore(wrap, el);
    wrap.appendChild(el);

    const spinner = document.createElement('span');
    spinner.setAttribute('data-subtotal-spinner', '');
    spinner.setAttribute('aria-hidden', 'true');
    spinner.style.position = 'absolute';
    spinner.style.inset = '0';
    spinner.style.display = 'none';
    spinner.style.alignItems = 'center';
    spinner.style.justifyContent = 'center';
    spinner.style.backdropFilter = 'blur(0.5px)';
    spinner.style.background = 'rgba(255,255,255,0.55)';
    spinner.innerHTML =
      `<svg viewBox="0 0 24 24" width="18" height="18" style="animation: hdrSpin 0.9s linear infinite;">
        <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
        <path d="M21 12a9 9 0 0 1-9 9" fill="none" stroke="currentColor" stroke-width="3"></path>
      </svg>`;
    wrap.appendChild(spinner);

    // add keyframes once
    if (!document.getElementById('hdrSpinStyle')) {
      const style = document.createElement('style');
      style.id = 'hdrSpinStyle';
      style.textContent = `@keyframes hdrSpin { from { transform: rotate(0deg);} to { transform: rotate(360deg);} }`;
      document.head.appendChild(style);
    }
  }

  const spinner = wrap.querySelector('[data-subtotal-spinner]');
  if (spinner) spinner.style.display = busy ? 'flex' : 'none';
  el.style.opacity = busy ? '0.5' : '';
}

function enforceMinusRules() {
  // Disable "-" when qty is 1 (require Remove button)
  root.querySelectorAll('[data-qty-input]').forEach((input) => {
    const qty = parseInt(input.value, 10) || 0;
    const key = input.dataset.key;
    if (!key) return;

    const minusBtn = root.querySelector(
      `[data-qty-change][data-key="${CSS.escape(key)}"][data-delta="-1"]`
    );
    if (minusBtn) {
      minusBtn.disabled = qty <= 1;
      minusBtn.setAttribute('aria-disabled', qty <= 1 ? 'true' : 'false');
    }
  });
}

function updateLineUiOptimistic(key, nextQty) {
  const line = getLineElByKey(key);
  if (!line) return;

  // qty input
  const input = line.querySelector(`[data-qty-input][data-key="${CSS.escape(key)}"]`);
  if (input) input.value = String(nextQty);

  // disable/enable minus
  const minusBtn = line.querySelector(`[data-qty-change][data-delta="-1"]`);
  if (minusBtn) {
    minusBtn.disabled = nextQty <= 1;
    minusBtn.setAttribute('aria-disabled', nextQty <= 1 ? 'true' : 'false');
  }

  // if line is removed, optimistically remove from DOM
  if (nextQty === 0) {
    line.remove();
  }
}

async function getCartJson() {
  const res = await fetch(`${routesRoot}cart.js`, { headers: { Accept: 'application/json' } });
  return await res.json();
}

function updateTotalsFromCartJson(cart) {
  // badge
  const badge = root.querySelector('[data-cart-count]');
  if (badge) badge.textContent = cart.item_count;

  // subtotal
  const subtotalEl = getSubtotalEl();
  if (subtotalEl) subtotalEl.textContent = centsToMoney(cart.total_price);
}

// ---------- CART: change + refresh ----------
async function cartChange(key, quantity) {
  await fetch(`${routesRoot}cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
}

async function loadCartDrawer() {
  const loadingEl = root.querySelector('[data-cart-loading]');
  const target = root.querySelector('[data-cart-contents]');
  if (!target) return;

  const sectionId = root.dataset.sectionId; // set in Liquid
  if (!sectionId) {
    console.warn('Missing data-section-id on [data-header-drawers]');
    return;
  }

  if (loadingEl) loadingEl.hidden = false;

  try {
    const res = await fetch(`${routesRoot}?section_id=${encodeURIComponent(sectionId)}`, {
      headers: { Accept: 'text/html' }
    });

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-contents]');
    if (fresh) target.innerHTML = fresh.innerHTML;
  } catch (e) {
    // swallow
  } finally {
    if (loadingEl) loadingEl.hidden = true;
  }
}

async function syncCartUiAccurate() {
  // Use cart.js to correct totals/badge (discounts etc)
  try {
    const cart = await getCartJson();
    updateTotalsFromCartJson(cart);
  } catch (e) {}
}

// Delegated clicks
document.addEventListener('click', async (e) => {
  const qtyBtn = e.target.closest('[data-qty-change]');
  const removeBtn = e.target.closest('[data-remove-line]');

  // Only handle clicks inside this header instance
  const insideRoot = (qtyBtn && root.contains(qtyBtn)) || (removeBtn && root.contains(removeBtn));
  if (!insideRoot) return;

  // Prevent accidental removal via "-" at 1 (enforced even if someone removes disabled attr)
  if (qtyBtn) {
    const key = qtyBtn.dataset.key;
    const delta = parseInt(qtyBtn.dataset.delta, 10);
    const line = getLineElByKey(key);
    const input = line?.querySelector(`[data-qty-input][data-key="${CSS.escape(key)}"]`);
    const current = parseInt(input?.value, 10) || 0;

    if (delta === -1 && current <= 1) return; // require Remove button
  }

  if (cartBusy) return;
  cartBusy = true;

  setSubtotalBusy(true);

  try {
    if (qtyBtn) {
      const key = qtyBtn.dataset.key;
      const delta = parseInt(qtyBtn.dataset.delta, 10);

      setCheckoutBusy(true, 'Updating...');

      const line = getLineElByKey(key);
      const input = line?.querySelector(`[data-qty-input][data-key="${CSS.escape(key)}"]`);
      const current = parseInt(input?.value, 10) || 0;
      const next = Math.max(1, current + delta);

      updateLineUiOptimistic(key, next);
      enforceMinusRules();

      await cartChange(key, next);
      await syncCartUiAccurate();

      await loadCartDrawer();
      enforceMinusRules();

      return;
    }

    if (removeBtn) {
      const key = removeBtn.dataset.key;

      setCheckoutBusy(true, 'Removing...');

      // Optimistic: remove line instantly
      updateLineUiOptimistic(key, 0);

      await cartChange(key, 0);
      await syncCartUiAccurate();

      await loadCartDrawer();
      enforceMinusRules();

      setCheckoutBusy(false);
    }
  } finally {
    setSubtotalBusy(false);
    setCheckoutBusy(false);
    cartBusy = false;
  }
});

window.addEventListener('cart:refresh', async (event) => {
  try {
    await loadCartDrawer();
    await syncCartUiAccurate();
    enforceMinusRules();

    if (event.detail?.open) {
      await openCart({ refresh: false });
    }
  } catch (e) {
    console.error('cart:refresh failed', e);
  }
});

// Optional: ensure minus rules applied on initial load if cart is already in DOM
enforceMinusRules();
})();
